import dayjs from "dayjs";
import { ErrorResponse, SelectChargeableTripsRequest } from "../../api";
import { usageTripSlice } from "../../features/UsageBased_Trips/store";
import { commonSlice, store } from "../../store";
import { JST, viewDate2numeric } from "../../utils/time";
import { api } from "../common/make_api";
import {
    ActionType,
    ResourceType,
    StatusType,
    sendLog,
} from "../common/send_log";

export async function set_start_date(startdate: string): Promise<void> {
    await store.dispatch(usageTripSlice.actions.update_start_date(startdate));
}

export async function set_end_date(enddate: string): Promise<void> {
    await store.dispatch(usageTripSlice.actions.update_end_date(enddate));
}

export async function select_usage_trips_by_driver(
    driverId: number
): Promise<void> {
    const state = store.getState();
    await store.dispatch(
        commonSlice.actions.updateSelectedDriverById(driverId)
    );
    const selectedMonth = dayjs(state.payments.selectedMonth!, "YYYY/MM", JST);
    const startDate = selectedMonth.date(1);
    const endDate = startDate.add(1, "month").date(1).add(-1, "date");
    await store.dispatch(usageTripSlice.actions.resetState());
    await store.dispatch(
        usageTripSlice.actions.update_start_date(startDate.format("YYYY-MM-DD"))
    );
    await store.dispatch(
        usageTripSlice.actions.update_end_date(endDate.format("YYYY-MM-DD"))
    );
}

export async function selectUsageTrip(): Promise<void> {
    store.dispatch(commonSlice.actions.startLoading());
    const state = store.getState();
    const officeId = state.common.selectedOfficeId;
    const driverid = state.common.selectedDriver?.driverId;
    let officeids = state.common.officeIds;

    if (!officeids) {
        officeids = [officeId];
    }

    if (officeId > -1) {
        officeids = [officeId];
    }

    try {
        const startdate = viewDate2numeric(state.usage.startDate);
        const enddate = viewDate2numeric(state.usage.endDate);

        const req: SelectChargeableTripsRequest = {
            officeId: officeId,
            driverId: driverid,
            startDate: startdate,
            endDate: enddate,
            officeIds: officeids,
        };

        const res = await api.getUsageTripAPI().selectChargeableTrips(req);

        sendLog(
            ResourceType.DRIVER_USAGE_TRIP,
            StatusType.GET_RESOURCE,
            ActionType.DRIVER_USAGE_TRIP
        );
        store.dispatch(usageTripSlice.actions.update_usage_trips(res));
    } catch (err) {
        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
        if (err.status && err.status == 500) {
            store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }

        const res = (await (err as Response).json()) as ErrorResponse;
        if (err["status"] == 401) {
            console.log("Console is reloading...", res);
            return;
        }

        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}
